// mycards strings (fr).
// Machine-drafted — review with a native speaker before launch.
const mycards = {
	mycards: {
		// Status tabs
		tabAll: 'Toutes',
		tabDraft: 'Brouillon',
		tabSent: 'Envoyées',
		tabScheduled: 'Programmées',
		tabWorkflow: 'Flux de travail',

		// View toggle
		gridView: 'Vue en grille',
		calendarView: 'Vue calendrier',

		// Search
		searchPlaceholder: 'Saisir le titre de la carte',

		// Date range filter
		last7Days: '7 derniers jours',
		last15Days: '15 derniers jours',
		last30Days: '30 derniers jours',
		last2Months: '2 derniers mois',
		last6Months: '6 derniers mois',
		lastYear: 'Année dernière',
		allCardsRange: 'Toutes les cartes',

		viewMore: 'Voir plus',

		// Empty state
		emptyState: "Vous n'avez pas encore de carte. Cliquez sur le bouton ci-dessous pour commencer.",
		createNewCard: 'Créer une nouvelle carte',

		// Folder bar
		foldersLabel: 'Dossiers',
		allCards: 'Toutes les cartes',
		newFolder: 'Nouveau dossier',
		addFolder: 'Ajouter',
		folderNamePlaceholder: 'Nom du dossier',
		addRemoveCards: 'Ajouter / retirer des cartes',
		renameFolderText: 'Renommer le dossier "%{name}"',
		deleteFolderTitle: 'Supprimer "%{name}" ?',
		deleteFolderText: "Le dossier sera supprimé. Les cartes qu'il contient sont conservées et simplement déclassées.",

		// Assign cards modal
		cardsInFolder: 'Cartes dans "%{name}"',
		selectedCount: '%{count} sélectionnées',
		searchCards: 'Rechercher des cartes…',
		noCardsFound: 'Aucune carte trouvée.',
		untitledCard: 'Carte sans titre',
		btnSave: 'Enregistrer',
		btnSaving: 'Enregistrement…',

		// Shared buttons
		btnCancel: 'Annuler',
		btnRename: 'Renommer',
		btnDelete: 'Supprimer',
		btnNo: 'Non',
		btnYes: 'Oui',
		btnEditAnyway: 'Modifier quand même',

		// Folder handler errors
		couldNotCreateFolder: 'Impossible de créer le dossier',
		couldNotRenameFolder: 'Impossible de renommer le dossier',
		couldNotDeleteFolder: 'Impossible de supprimer le dossier',

		// Card handler dialogs
		cardAlreadyDeliveredTitle: 'Carte déjà livrée',
		cardAlreadyDeliveredText: 'Vous pouvez cloner cette carte pour en programmer une nouvelle',
		workflowWarningTitle: 'Cette carte est utilisée dans un flux de travail',
		workflowWarningText: 'Modifier les balises de fusion ou le contenu peut casser vos flux de travail existants. Êtes-vous sûr de vouloir continuer ?',
		openCardErrorTitle: "Un problème est survenu lors de l'ouverture de cette carte. Veuillez contacter le support",
		deleteCardTitle: 'Êtes-vous sûr ?',
		deleteCardText: 'Voulez-vous supprimer cette carte ?',
		errorTitle: 'Erreur',
	} as Record<string, string>,
};
export default mycards;
